import { createStore } from '@stencil/store';
import { Environment, getEnvironment } from '../entities/environment';
import {
  DEFAULT_ENVIRONMENT,
  DEFAULT_LOCALE,
  DEFAULT_UNREAD_MESSAGES_COUNT,
  LOGGED_OUT_USER_STATUS,
  NavigationMode,
  NavigationModeType,
  NavigationTheme,
  NavigationThemeType
} from '../utility/constants';
import { Application, ApplicationType } from '../utility/constants/app';

export interface NavStateType {
  loggedInState: string;
  unreadMessagesCount: number;
  userConsent: boolean;
  env: Environment;
  app: ApplicationType;
  usingKeyboard: boolean;
  locale: string;
  theme: NavigationThemeType;
  mode: NavigationModeType;
  initialRoutingPath?: string;
}

export const navStateDefaultData = {
  loggedInState: LOGGED_OUT_USER_STATUS,
  unreadMessagesCount: DEFAULT_UNREAD_MESSAGES_COUNT,
  userConsent: false,
  env: getEnvironment(DEFAULT_ENVIRONMENT),
  app: Application.default,
  usingKeyboard: false,
  locale: DEFAULT_LOCALE,
  theme: NavigationTheme.light,
  mode: NavigationMode.navbar
};

export const navStateStore = createStore<NavStateType>(navStateDefaultData);
